export const articlesAnalysisExtra = [
  {
    slug: 'reading-candlestick-charts',
    category: 'วิเคราะห์ Forex',
    categorySlug: 'forex-analysis',
    title: 'แท่งเทียน Forex คืออะไร และอ่านอย่างไร',
    description:
      'เรียนรู้โครงสร้างของแท่งเทียน ตั้งแต่ไส้บน ไส้ล่าง ตัวแท่ง ไปจนถึงวิธีตีความแรงซื้อแรงขายในแต่ละแท่งอย่างไม่รีบสรุป',
    readingTime: '7 นาที',
    updatedDate: '2026-10-18',
    level: 'เริ่มต้น',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20single%20candlestick%20anatomy%20illustration%20with%20teal%20body%20and%20warm%20orange%20wicks%20on%20clean%20light%20background%20editorial%20flat%20fintech%20design%20no%20text%20no%20people&width=1200&height=675&seq=art-candlestick-reading-01&orientation=landscape',
    tags: ['แท่งเทียน', 'อ่านกราฟ', 'พื้นฐาน'],
    intro: [
      'แท่งเทียนหนึ่งแท่งคือสรุปการเคลื่อนไหวของราคาในช่วงเวลาหนึ่ง ประกอบด้วยราคาเปิด ราคาปิด ราคาสูงสุด และราคาต่ำสุด',
      'การอ่านแท่งเทียนให้เป็นคือพื้นฐานของการวิเคราะห์กราฟทั้งหมด เพราะข้อมูลอื่นบนหน้าจอส่วนใหญ่ถูกคำนวณมาจากราคาเหล่านี้',
    ],
    sections: [
      {
        id: 'structure',
        heading: 'สี่ตัวเลขที่อยู่ในแท่งเดียว',
        paragraphs: [
          'ตัวแท่งคือช่วงระหว่างราคาเปิดกับราคาปิด ส่วนไส้บนและไส้ล่างบอกระยะที่ราคาเคยวิ่งไปไกลกว่านั้นในช่วงเวลาเดียวกัน สีของแท่งเป็นเพียงการเปรียบเทียบราคาเปิดกับราคาปิดในกรอบเวลานั้น',
        ],
        bullets: [
          'ไส้บนยาวบ่งชี้ว่าราคาเคยขึ้นไปสูงแต่ถูกกดกลับลงมา',
          'ไส้ล่างยาวบ่งชี้ว่าราคาเคยลงต่ำแต่มีแรงซื้อดันกลับ',
          'ตัวแท่งสั้นและไส้ยาวทั้งสองข้างคือความลังเลของตลาด',
        ],
        steps: [],
      },
      {
        id: 'context',
        heading: 'แท่งเทียนต้องอ่านในบริบท',
        paragraphs: [
          'แท่งเทียนไส้ยาวแท่งเดียวกันอาจหมายถึงการกลับตัวหรือแค่การพักราคา ขึ้นอยู่กับว่ามันเกิดที่ตำแหน่งใดของกราฟ ดังนั้นควรดูตำแหน่งเทียบกับแนวรับแนวต้านและทิศทางหลักก่อนเสมอ',
        ],
        bullets: ['แท่งเดียวกันให้ความหมายต่างกันตามตำแหน่ง', 'กรอบเวลาใหญ่ให้ข้อมูลที่น่าเชื่อถือกว่า', 'ควรรอแท่งปิดก่อนสรุป'],
        steps: [],
      },
      {
        id: 'mistakes',
        heading: 'ข้อผิดพลาดที่มือใหม่ทำบ่อย',
        paragraphs: [
          'การอ่านแท่งเทียนแท่งเดียวแล้วสรุปทิศทางทันทีเป็นเรื่องที่พบมากที่สุด อีกจุดคือการจำชื่อรูปแบบแท่งเทียนโดยยังไม่เข้าใจว่าแรงซื้อแรงขายเกิดขึ้นตรงไหน',
          'อีกข้อที่พบบ่อยคือใช้กรอบเวลา M1 หรือ M5 อ่านสัญญาณแล้วเปิดไม้ทันที ซึ่งในหนึ่งชั่วโมงจะมีแท่งเทียนผันผวนสลับขึ้นลงหลายสิบแท่งจนสัญญาณขัดกันเอง ทางที่ดีควรดูแท่งปิดของ H1 หรือ H4 อย่างน้อย 3 แท่งเรียงกันก่อนจึงถือว่ารูปแบบนั้นน่าเชื่อถือ',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'แท่งเทียนสีเขียวกับสีแดงต่างกันอย่างไร',
        a: 'สีเขียวหมายถึงราคาปิดสูงกว่าราคาเปิดในกรอบเวลานั้น ส่วนสีแดงหมายถึงราคาปิดต่ำกว่าราคาเปิด สีบอกทิศทางของแท่ง แต่ไม่ได้บอกขนาดของโอกาสในอนาคต',
        a2: 'ตัวเลขที่ช่วยได้คือ แท่งที่ไส้บนยาวกว่าไส้ล่าง 2 เท่าและมีตัวเล็ก แสดงว่าแรงขายสวนกลับเข้ามาระหว่างวัน สำหรับคู่เงินหลัก แท่ง H1 ที่เคลื่อนเกิน 30 Pip ถือว่าผิดปกติ และมักตามด้วยการย้อนกลับ 40-50% ของแท่งนั้น',
      },
      {
        q: 'ต้องใช้กรอบเวลาไหนอ่านแท่งเทียน',
        a: 'เริ่มจากกรอบเวลาที่ใหญ่พอให้เห็นแนวโน้ม เช่น H1 หรือ H4 แล้วค่อยลงมาดูกรอบเวลาเล็กเพื่อหาจุดอ้างอิง ไม่แนะนำให้เริ่มจากกรอบเวลานาทีเพราะมีสัญญาณรบกวนมาก',
        a2: 'ตัวเลขที่ใช้ได้คือ อ่าน H4 ย้อนหลัง 100-200 แท่งก่อน แล้วจึงดู H1 เพื่อหาจุดเข้า ถ้าเปลี่ยนไปอ่าน M5 โดยยังไม่เห็นภาพ H4 คุณจะเห็นแนวโน้มที่จริงเป็นเพียงการแกว่ง 20-30 Pip ภายในกรอบใหญ่',
      },
    ],
    related: ['forex-technical-analysis', 'support-resistance', 'how-to-analyze-forex-chart'],
  },
  {
    slug: 'forex-trend-direction',
    category: 'วิเคราะห์ Forex',
    categorySlug: 'forex-analysis',
    title: 'วิธีดูแนวโน้มขาขึ้นและขาลงในตลาด Forex',
    description:
      'วิธีแยกแนวโน้มขาขึ้น ขาลง และตลาดไซด์เวย์จากโครงสร้างจุดสูงจุดต่ำ พร้อมตัวอย่างการอ่านที่ผิดพลาดบ่อย',
    readingTime: '8 นาที',
    updatedDate: '2026-10-16',
    level: 'เริ่มต้น',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20rising%20and%20falling%20staircase%20price%20structure%20illustration%20teal%20upward%20steps%20warm%20orange%20downward%20steps%20clean%20light%20background%20editorial%20flat%20design%20no%20text&width=1200&height=675&seq=art-forex-trend-direction-01&orientation=landscape',
    tags: ['แนวโน้ม', 'โครงสร้างตลาด', 'อ่านกราฟ'],
    intro: [
      'แนวโน้มคือทิศทางหลักที่ราคาเคลื่อนไหว ซึ่งเกิดจากจุดสูงและจุดต่ำที่ไล่กันขึ้นหรือไล่กันลง',
      'การรู้ว่าตลาดอยู่ในภาวะไหนช่วยให้เลือกเครื่องมือได้ถูก และลดการเข้าออเดอร์สวนทางโดยไม่รู้ตัว',
    ],
    sections: [
      {
        id: 'structure',
        heading: 'อ่านจากจุดสูงและจุดต่ำ',
        paragraphs: [
          'แนวโน้มขาขึ้นคือการที่ราคาทำจุดสูงใหม่สูงขึ้นและจุดต่ำใหม่ก็ยกขึ้นตาม ส่วนแนวโน้มขาลงคือจุดสูงใหม่ต่ำลงและจุดต่ำใหม่ก็ต่ำลง',
        ],
        bullets: ['ขาขึ้น: Higher High และ Higher Low', 'ขาลง: Lower High และ Lower Low', 'ไซด์เวย์: จุดสูงจุดต่ำอยู่ในกรอบเดิม'],
        steps: [],
      },
      {
        id: 'timeframe',
        heading: 'แนวโน้มขึ้นกับกรอบเวลาที่มอง',
        paragraphs: [
          'กราฟเดียวกันสามารถเป็นขาขึ้นในกรอบรายวันและเป็นขาลงในกรอบ 15 นาทีพร้อมกันได้ นี่ไม่ใช่ความขัดแย้ง แต่คือคนละระดับของข้อมูล',
        ],
        bullets: ['เลือกกรอบใหญ่กำหนดทิศทาง', 'ใช้กรอบเล็กหาจังหวะ', 'อย่าเอาข้อสรุปต่างกรอบมาเปรียบกันตรง ๆ'],
        steps: [],
      },
      {
        id: 'change',
        heading: 'สังเกตตอนแนวโน้มเริ่มเปลี่ยน',
        paragraphs: [
          'สัญญาณแรกของการเปลี่ยนแนวโน้มคือการที่ราคาไม่สามารถทำจุดสูงใหม่ได้ หรือหลุดจุดต่ำล่าสุดที่เคยยืนได้ การยืนยันมักต้องใช้หลายแท่ง ไม่ใช่แท่งเดียว',
          'ลำดับที่ควรเฝ้าคือ 1) ราคาทำจุดสูงใหม่แต่ปิดต่ำกว่าเดิม 2) ราคาหลุด swing low ล่าสุดด้วยแท่งปิด ไม่ใช่แค่ไส้เทียน 3) มีแท่งตามมาปิดต่ำกว่าจุดเดิมอีก 1 ถึง 2 แท่ง ถ้าครบทั้งสามข้อจึงเรียกว่าการเปลี่ยนโครงสร้าง เพราะการหลุดด้วยไส้เทียนเพียงแท่งเดียวแล้วเด้งกลับพบได้บ่อยมากบน H4' ,
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'ตลาดไซด์เวย์ควรเทรดอย่างไร',
        a: 'ตลาดไซด์เวย์เหมาะกับการเล่นในกรอบมากกว่าการตามแนวโน้ม แต่ต้องยอมรับว่ากรอบอาจหลุดได้ทุกเมื่อ จึงควรกำหนดจุดผิดไว้ชัดเจนก่อนเข้าเสมอ',
        a2: 'ตัวเลขที่ช่วยกำหนดกรอบคือ ถ้าราคาแกว่งอยู่ในช่วง 40-60 Pip ติดต่อกันเกิน 20 แท่ง ให้ถือว่าเป็นไซด์เวย์ และควรเล่นจากขอบกรอบเข้าหากลางด้วยเป้าเพียง 60-70% ของความกว้างกรอบ เพราะการรอให้ถึงอีกด้านมักพลาด',
      },
      {
        q: 'ต้องใช้เส้นแนวโน้มช่วยไหม',
        a: 'เส้นแนวโน้มช่วยให้เห็นภาพเร็วขึ้น แต่ควรอิงจากจุดสูงจุดต่ำจริงบนกราฟ ไม่ใช่ลากให้พอดีกับสิ่งที่อยากเห็น',
        a2: 'ข้อควรระวังคือ ถ้าต้องขยับจุดยึดเกิน 2 ครั้งเพื่อให้เส้นยังแตะราคาได้ แสดงว่าเส้นนั้นไม่ได้สะท้อนโครงสร้างจริง วิธีที่ตรงกว่าคือใช้เส้นแนวนอนจากจุดสูงจุดต่ำสำคัญแทน',
      },
    ],
    related: ['reading-candlestick-charts', 'support-resistance', 'technical-indicators'],
  },
  {
    slug: 'moving-average-indicator',
    category: 'วิเคราะห์ Forex',
    categorySlug: 'forex-analysis',
    title: 'Moving Average คืออะไร และใช้อย่างไร',
    description:
      'ทำความรู้จักเส้นค่าเฉลี่ยเคลื่อนที่ ตั้งแต่ SMA กับ EMA ความหมายของระยะเวลา ไปจนถึงข้อจำกัดที่มือใหม่มักมองข้าม',
    readingTime: '7 นาที',
    updatedDate: '2026-10-14',
    level: 'ปานกลาง',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20smooth%20moving%20average%20curve%20over%20teal%20price%20line%20on%20clean%20light%20background%20editorial%20flat%20fintech%20illustration%20no%20text%20no%20people&width=1200&height=675&seq=art-moving-average-01&orientation=landscape',
    tags: ['Moving Average', 'อินดิเคเตอร์', 'แนวโน้ม'],
    intro: [
      'Moving Average คือค่าเฉลี่ยราคาในช่วงเวลาที่กำหนด แล้วนำมาวาดเป็นเส้นต่อเนื่องบนกราฟ',
      'มันไม่ได้ทำนายอนาคต แต่ช่วยลดสัญญาณรบกวนของราคาให้เห็นทิศทางหลักชัดขึ้น',
    ],
    sections: [
      {
        id: 'types',
        heading: 'SMA กับ EMA ต่างกันตรงไหน',
        paragraphs: [
          'SMA ให้ค่าน้ำหนักเท่ากันทุกแท่ง ส่วน EMA ให้น้ำหนักกับแท่งล่าสุดมากกว่า ทำให้ EMA ตอบสนองเร็วขึ้นแต่ก็ไวต่อสัญญาณหลอกมากกว่า',
        ],
        bullets: ['SMA เนียนกว่า เหมาะกับภาพรวมแนวโน้ม', 'EMA เร็วกว่า เหมาะกับกรอบเวลาเล็ก', 'ไม่มีค่าที่ดีที่สุดสำหรับทุกคน'],
        steps: [],
      },
      {
        id: 'usage',
        heading: 'ใช้งานจริงอย่างไร',
        paragraphs: [
          'การใช้ที่พบบ่อยคือดูว่าราคาอยู่เหนือหรือใต้เส้น เพื่อประเมินทิศทางหลัก และใช้เส้นเป็นแนวรับแนวต้านแบบเคลื่อนที่ โดยเฉพาะเส้นระยะยาวที่ตลาดให้ความสนใจ',
        ],
        bullets: ['ราคายืนเหนือเส้นระยะยาว = บริบทขาขึ้น', 'เส้นระยะสั้นตัดขึ้นเส้นระยะยาว = โมเมนตัมเปลี่ยน', 'ใช้ร่วมกับโครงสร้างราคาเสมอ'],
        steps: [],
      },
      {
        id: 'limits',
        heading: 'ข้อจำกัดที่ต้องรู้',
        paragraphs: [
          'Moving Average คำนวณจากอดีต จึงตอบสนองช้ากว่าราคาเสมอ ในตลาดไซด์เวย์เส้นจะตัดกันไปมาและให้สัญญาณที่ใช้ไม่ได้จริง',
          'ตัวเลขที่อธิบายเรื่องนี้ได้ดีคือ EMA 20 บน H1 จะตามราคาช้ากว่าประมาณ 10 แท่ง หรือราว 10 ชั่วโมง และเมื่อตลาดแกว่งในกรอบแคบ 25 Pip เส้น EMA 20 กับ 50 จะตัดกันได้หลายครั้งในหนึ่งวัน สัญญาณซื้อขายที่ได้จึงมีอัตราถูกต้องต่ำกว่าช่วงที่มีแนวโน้มชัดเจนมาก' ,
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'ควรใช้ Moving Average กี่เส้น',
        a: 'หนึ่งถึงสองเส้นก็เพียงพอสำหรับมือใหม่ การใส่หลายเส้นพร้อมกันทำให้ตัดสินใจยากขึ้นโดยไม่ได้ข้อมูลใหม่',
        a2: 'ตัวอย่างที่ใช้ได้คือ EMA 20 สำหรับจังหวะสั้น และ EMA 50 สำหรับแนวโน้มกลาง ถ้าใส่ 4-5 เส้นพร้อมกัน คุณจะเจอจุดตัดกันหลายจุดในหนึ่งวัน และมักเลือกเส้นที่ให้สัญญาณตรงกับที่อยากเข้า',
      },
      {
        q: 'Moving Average ใช้แทนแนวรับแนวต้านได้ไหม',
        a: 'ใช้เป็นแนวรับแนวต้านแบบเคลื่อนที่ได้บางสถานการณ์ แต่แนวรับแนวต้านจากจุดสูงจุดต่ำจริงบนกราฟมักมีความหมายมากกว่า',
        a2: 'ข้อจำกัดที่ชัดคือ เส้นค่าเฉลี่ยลากตามราคา จึงไม่เคยถูกแตะแล้วเด้งอย่างแม่นยำเหมือนระดับแนวนอน ในตลาดไซด์เวย์เส้นนี้จะถูกตัดผ่านไปมาหลายครั้งจนไม่มีความหมาย',
      },
    ],
    related: ['technical-indicators', 'forex-trend-direction', 'how-to-analyze-forex-chart'],
  },
  {
    slug: 'double-top-double-bottom',
    category: 'วิเคราะห์ Forex',
    categorySlug: 'forex-analysis',
    title: 'Double Top และ Double Bottom คืออะไร',
    description:
      'อ่านรูปแบบกราฟ Double Top และ Double Bottom อย่างระวัง เข้าใจสิ่งที่ต้องรอยืนยัน และเหตุผลที่รูปแบบกลับตัวมักล้มเหลว',
    readingTime: '7 นาที',
    updatedDate: '2026-10-12',
    level: 'ปานกลาง',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20double%20top%20chart%20pattern%20illustration%20two%20teal%20peaks%20with%20warm%20orange%20neckline%20on%20clean%20light%20background%20editorial%20flat%20fintech%20no%20text&width=1200&height=675&seq=art-double-top-01&orientation=landscape',
    tags: ['รูปแบบกราฟ', 'กลับตัว', 'วิเคราะห์'],
    intro: [
      'Double Top คือรูปแบบที่ราคาขึ้นไปแตะระดับสูงเดิมสองครั้งแล้วไม่ผ่าน ส่วน Double Bottom คือการลงไปแตะระดับต่ำเดิมสองครั้งแล้วเด้งกลับ',
      'รูปแบบเหล่านี้บอกว่าตลาดกำลังสูญเสียโมเมนตัมฝั่งเดิม แต่ไม่ได้ยืนยันการกลับตัวจนกว่าราคาจะผ่านระดับคอ',
    ],
    sections: [
      {
        id: 'shape',
        heading: 'หน้าตาของรูปแบบ',
        paragraphs: [
          'จุดสำคัญไม่ใช่ความสวยงามของยอดสองยอด แต่คือระดับคอกลางที่เชื่อมระหว่างยอดทั้งสอง ถ้าราคาไม่ผ่านระดับนี้ รูปแบบยังไม่สมบูรณ์',
        ],
        bullets: ['ยอดสองยอดควรอยู่ในโซนเดียวกัน ไม่จำเป็นต้องเท่ากันเป๊ะ', 'ระยะระหว่างยอดไม่ควรห่างกันจนขาดบริบท', 'ระดับคอคือจุดอ้างอิงหลัก'],
        steps: [],
      },
      {
        id: 'confirm',
        heading: 'สิ่งที่ต้องรอเพื่อยืนยัน',
        paragraphs: [
          'ควรเห็นราคาปิดผ่านระดับคออย่างชัดเจนในกรอบเวลาที่ใช้วิเคราะห์ และหากมีแรงตามมาหลังการผ่านระดับ ความน่าเชื่อถือจะสูงขึ้น',
        ],
        bullets: ['รอแท่งปิด ไม่ใช่ราคาแตะระหว่างแท่ง', 'ระวังการทะลุหลอกที่เด้งกลับเร็ว', 'ตรวจกรอบเวลาใหญ่ประกอบ'],
        steps: [],
      },
      {
        id: 'limit',
        heading: 'ทำไมรูปแบบถึงล้มเหลวบ่อย',
        paragraphs: [
          'ตลาดไม่ได้มีหน้าที่ทำตามรูปแบบที่เราวาด การจับรูปแบบทุกจุดที่คล้ายกันจะทำให้เห็นสัญญาณมากเกินจริง ควรใช้ร่วมกับแนวโน้มหลักและกำหนดจุดที่คิดผิดไว้ก่อนเสมอ',
          'วิธีกรองที่ใช้ได้จริงคือ รูปแบบต้องมีจุดสูงหรือต่ำต่างกันอย่างน้อย 2 ถึง 3% และควรอยู่ในทิศทางเดียวกับแนวโน้มบน D1 ถ้ารูปแบบโผล่ในตลาดไซด์เวย์ โอกาสที่ราคาจะทะลุแล้วไปต่อจริงจะลดลงเกือบครึ่ง',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'Double Top ต้องกลับตัวทุกครั้งไหม',
        a: 'ไม่ต้อง รูปแบบเป็นเพียงการบอกว่าโมเมนตัมฝั่งเดิมอ่อนลง ไม่ใช่การรับประกันการกลับตัว และอาจกลายเป็นเพียงการพักของแนวโน้มเดิม',
        a2: 'ตัวเลขที่ควรดูคือ ราคาต้องปิดพ้นระดับคอก่อนจึงถือว่ารูปแบบสมบูรณ์ และเป้าหมายที่วัดได้คือความสูงจากหัวถึงคอ ประมาณ 60-70% ของกรณีจะไปถึงเป้า ส่วนอีกราว 30-40% กลับกลายเป็นการพักของแนวโน้มเดิม',
      },
      {
        q: 'ใช้กับกรอบเวลาไหนได้บ้าง',
        a: 'ใช้ได้ทุกกรอบเวลา แต่รูปแบบบนกรอบเวลาใหญ่มักมีความหมายมากกว่า และควรหลีกเลี่ยงการอ่านรูปแบบบนกรอบเล็กมาก',
        a2: 'ตัวเลขที่ต่างชัดคือ Double Top บน M5 เกิดวันละหลายครั้งและล้มเหลวราว 6-7 ใน 10 ครั้ง ส่วนบน H4 หรือ D1 เกิดเดือนละไม่กี่ครั้งและมีอัตราสำเร็จสูงกว่าชัดเจน',
      },
    ],
    related: ['support-resistance', 'forex-technical-analysis', 'price-action'],
  },
  {
    slug: 'how-to-analyze-forex-chart',
    category: 'วิเคราะห์ Forex',
    categorySlug: 'forex-analysis',
    title: 'วิธีวิเคราะห์กราฟ Forex ทีละขั้นตอน',
    description:
      'ลำดับการวิเคราะห์กราฟ Forex ตั้งแต่ดูแนวโน้ม หาโซนราคาสำคัญ ตรวจอินดิเคเตอร์ ไปจนถึงการยอมรับข้อจำกัดก่อนตัดสินใจ',
    readingTime: '9 นาที',
    updatedDate: '2026-10-10',
    level: 'ปานกลาง',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20four%20step%20chart%20analysis%20diagram%20teal%20candlesticks%20warm%20orange%20annotation%20guides%20clean%20light%20background%20editorial%20flat%20fintech%20no%20text&width=1200&height=675&seq=art-analyze-chart-steps-01&orientation=landscape',
    tags: ['วิธีวิเคราะห์', 'อ่านกราฟ', 'ขั้นตอน'],
    intro: [
      'การวิเคราะห์กราฟที่ดีไม่ได้เริ่มจากการหาสัญญาณที่เร็วที่สุด แต่เริ่มจากการตั้งคำถามว่าตลาดกำลังอยู่ในภาวะใด',
      'บทความนี้รวบรวมลำดับการทำงานที่ใช้ซ้ำได้ทุกครั้งที่เปิดกราฟ เพื่อให้การตัดสินใจมีเหตุผลรองรับ',
    ],
    sections: [
      {
        id: 'context',
        heading: 'ขั้นที่ 1 ดูบริบทและแนวโน้ม',
        paragraphs: [
          'เปิดกรอบเวลาใหญ่ก่อนเพื่อดูทิศทางหลัก จากนั้นจึงลงมาที่กรอบเวลาเล็กที่ใช้หาจุดอ้างอิง การมองข้ามขั้นนี้ทำให้สัญญาณที่เห็นในกรอบเล็กขัดกับบริบท',
        ],
        bullets: ['เริ่มจาก Daily หรือ H4', 'จดว่ากำลังขึ้น ลง หรือไซด์เวย์', 'หลีกเลี่ยงการเทรดสวนแนวโน้มโดยไม่มีเหตุผลชัด'],
        steps: [],
      },
      {
        id: 'levels',
        heading: 'ขั้นที่ 2 ทำเครื่องหมายโซนราคาสำคัญ',
        paragraphs: [
          'ลากโซนแนวรับแนวต้านจากจุดที่ราคาเคยหยุดหรือกลับตัวจริง ไม่ใช่จากตัวเลขกลม แล้วระบุว่าปัจจุบันราคาอยู่ใกล้โซนใด',
        ],
        bullets: ['โซนสำคัญควรถูกแตะหลายครั้ง', 'บันทึกว่าโซนใดถูกเบรกไปแล้ว', 'มองโซนเป็นพื้นที่ ไม่ใช่เส้นเดียว'],
        steps: [],
      },
      {
        id: 'tools',
        heading: 'ขั้นที่ 3 ใช้เครื่องมือยืนยัน',
        paragraphs: [
          'เลือกอินดิเคเตอร์หนึ่งหรือสองตัวที่เข้าใจจริง เช่น Moving Average สำหรับดูแนวโน้ม หรือ RSI สำหรับดูโมเมนตัม แล้วดูว่ามันสนับสนุนหรือขัดกับสิ่งที่กราฟบอก',
        ],
        bullets: ['อินดิเคเตอร์คือตัวยืนยัน ไม่ใช่ตัวตัดสิน', 'ถ้าสัญญาณขัดกัน ให้ยึดโครงสร้างราคา', 'ลดจำนวนเครื่องมือเมื่อวิเคราะห์ไม่ชัด'],
        steps: [],
      },
      {
        id: 'limits',
        heading: 'ขั้นที่ 4 ยอมรับข้อจำกัดและกำหนดจุดที่คิดผิด',
        paragraphs: [
          'เมื่อได้ข้อสรุปแล้ว ต้องรู้ว่าอะไรจะทำให้ข้อสรุปนั้นผิด และยอมรับผลนั้นก่อนเปิดออเดอร์ นี่คือส่วนที่เชื่อมการวิเคราะห์เข้ากับการบริหารความเสี่ยง',
          'ประโยคที่ควรเขียนก่อนกด Buy ทุกครั้งคือ ถ้าราคาปิดต่ำกว่าโซนนี้ 1 ถึง 2 แท่ง แปลว่าการวิเคราะห์ของฉันผิด และฉันจะยอมขาดทุนไม่เกิน 1% ของพอร์ต ขั้นตอนนี้ใช้เวลาไม่ถึง 30 วินาที แต่ช่วยลดการถือไม้ที่ผิดแผนจนกลายเป็นการขาดทุนก้อนใหญ่' ,
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'ต้องวิเคราะห์กราฟทุกวันไหม',
        a: 'ไม่จำเป็น ความถี่ขึ้นอยู่กับกรอบเวลาที่ใช้ หากเทรดกรอบรายวัน การทบทวนวันละครั้งก็เพียงพอ สิ่งสำคัญคือทำตามลำดับเดิมอย่างสม่ำเสมอ',
        a2: 'ลำดับที่ใช้ซ้ำได้คือ ดูแนวโน้มจาก D1 หรือ H4 (2-3 นาที) หาโซนสำคัญ (3-5 นาที) ตรวจอินดิเคเตอร์ 1 ตัว (1 นาที) แล้วเขียนแผนก่อนกด ใช้เวลารวมไม่เกิน 15 นาทีต่อครั้ง ซึ่งทำวันละครั้งก็เพียงพอสำหรับกรอบรายวัน',
      },
      {
        q: 'วิเคราะห์ถูกทุกครั้งได้ไหม',
        a: 'ไม่ได้ การวิเคราะห์เป็นเรื่องของความน่าจะเป็น สิ่งที่ควบคุมได้คือกระบวนการตัดสินใจและขนาดความเสี่ยงต่อออเดอร์',
        a2: 'ตัวเลขที่ควรจำคือ แม้ระบบชนะ 60% ก็ยังมีช่วงขาดทุนติดกัน 5-6 ครั้งใน 200 ไม้ สิ่งที่ทำให้อยู่รอดคือความเสี่ยง 1% ต่อไม้ ซึ่งทำให้ช่วงแย่ที่สุดกินทุนไม่เกิน 6% ไม่ใช่การวิเคราะห์ที่แม่นขึ้น',
      },
    ],
    related: ['forex-trend-direction', 'support-resistance', 'technical-indicators'],
  },
];